<template>
    <div>
        <div id="app" class="app">
            <router-view />
        </div>
    </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-constant-condition */
import dateFormat from "date-format";
import {
    cookieName,
    channelCookieName,
    readChannelCookieString,
    getChannelCookieString,
    readCookieString,
    generateCookie,
    isMatchingWeight,
    updateWeight
} from "@/common/experiments";
import { getCurrentSubdomain } from "@/common/functions";

export default {
    methods: {
        checkLastVisited() {
            const lastVisitedTime = window.$cookies.get("last_visited");
            this.$store.commit("updateLastVisited", lastVisitedTime);
            this.setLastVisited();
        },
        setLastVisited() {
            const currentTime = dateFormat(dateFormat.ISO8601_WITH_TZ_OFFSET_FORMAT);
            window.$cookies.set("last_visited", currentTime, "7d");
        },
        testExpRedis() {
            const data = {
                date: "200120",
                oldChannels: {
                    A: 50,
                    B: 50
                }
            };

            const l = {
                initial: {},
                final: {},
                redistributions: {}
            };

            this.$cookies.set(channelCookieName, getChannelCookieString(data.oldChannels), -1);

            for (var i = 0; i < 1000; i++) {
                const startCookieData = readCookieString(generateCookie(null, data.oldChannels));
                startCookieData.weight = data.oldChannels[startCookieData.channel];
                const startChannel = startCookieData.channel;
                l.initial[startChannel] = l.initial[startChannel] ? l.initial[startChannel] + 1 : 1;

                const isMatch = isMatchingWeight(startCookieData);
                let newCookieData;
                if (isMatch) {
                    newCookieData = Object.assign({}, startCookieData);
                } else {
                    newCookieData = updateWeight(startCookieData, data.oldChannels);
                }

                const newChannel = newCookieData.channel;
                l.final[newChannel] = l.final[newChannel] ? l.final[newChannel] + 1 : 1;

                if (startChannel !== newChannel) {
                    const redisKey = `${startChannel}_to_${newChannel}`;
                    l.redistributions[redisKey] = l.redistributions[redisKey]
                        ? l.redistributions[redisKey] + 1
                        : 1;
                }

                l.oldChannels = getChannelCookieString(data.oldChannels);
                l.newChannels = getChannelCookieString();
            }
        }
    },
    created() {
        if (window.__TEST__ !== true) {
            const subdomainsToTest = [
                "sentence",
                "examples",
                "grammar",
                "reference",
                "abbreviations",
                "esl",
                "education"
            ];

            // Change this value to 1 if you want to run the test.
            if (1) {
                const boundTest = this.testExpRedis.bind(this);
                boundTest();
            }

            const expCookie = this.$cookies.get(cookieName);
            let cookieData = readCookieString(expCookie);
            if (cookieData === null) {
                this.$cookies.set(cookieName, generateCookie(), -1);
                this.$cookies.set(channelCookieName, getChannelCookieString(), -1);
                cookieData = readCookieString(this.$cookies.get(cookieName));
            }
            if (!isMatchingWeight(cookieData)) {
                const channelCookie = this.$cookies.get(channelCookieName);
                const oldChannels = readChannelCookieString(channelCookie);
                cookieData = updateWeight(cookieData, oldChannels);
                this.$cookies.set(cookieName, generateCookie(cookieData.channel), -1);
                this.$cookies.set(channelCookieName, getChannelCookieString(), -1);
                cookieData = readCookieString(this.$cookies.get(cookieName));
            }

            this.$store.commit("ABTest/loadExperiments", cookieData);
            if (this.$ga) {
                // this.$ga.set("dimension2", `v_${cookieData.channel}`);

                if (subdomainsToTest.includes(getCurrentSubdomain())) {
                    // TODO: Set FEATURE_A and FEATURE_B to test
                    // this.$ga.set(
                    //     "dimension2",
                    //     cookieData.channel === "A" ? FEATURE_A : FEATURE_B
                    // );
                }
            }
            window[cookieName] = cookieData;

            this.checkLastVisited();
        }
    }
};
</script>

<style lang="scss">
@import "@/assets/scss/_theme.scss";

#app {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue